const MuiTypography = {
    root: {
        margin: 0,
        marginBottom: '8px',
    },
};

export default MuiTypography;
